export const ADD_BREAKFAST_REQUEST = "ADD_BREAKFAST_REQUEST";
export const ADD_BREAKFAST_SUCCESS = "ADD_BREAKFAST_SUCCESS";
export const ADD_BREAKFAST_FAILURE = "ADD_BREAKFAST_FAILURE";

export const GET_BREAKFAST_REQUEST = "GET_BREAKFAST_REQUEST";
export const GET_BREAKFAST_SUCCESS = "GET_BREAKFAST_SUCCESS";
export const GET_BREAKFAST_FAILURE = "GET_BREAKFAST_FAILURE";

export const DELETE_BREAKFAST_REQUEST = "DELETE_BREAKFAST_REQUEST";
export const DELETE_BREAKFAST_SUCCESS = "DELETE_BREAKFAST_SUCCESS";
export const DELETE_BREAKFAST_FAILURE = "DELETE_BREAKFAST_FAILURE";

export const ADD_LUNCH_REQUEST = "ADD_LUNCH_REQUEST";
export const ADD_LUNCH_SUCCESS = "ADD_LUNCH_SUCCESS";
export const ADD_LUNCH_FAILURE = "ADD_LUNCH_FAILURE";

export const GET_LUNCH_REQUEST = "GET_LUNCH_REQUEST";
export const GET_LUNCH_SUCCESS = "GET_LUNCH_SUCCESS";
export const GET_LUNCH_FAILURE = "GET_LUNCH_FAILURE";

export const DELETE_LUNCH_REQUEST = "DELETE_LUNCH_REQUEST";
export const DELETE_LUNCH_SUCCESS = "DELETE_LUNCH_SUCCESS";
export const DELETE_LUNCH_FAILURE = "DELETE_LUNCH_FAILURE";

export const ADD_DINNER_REQUEST = "ADD_DINNER_REQUEST";
export const ADD_DINNER_SUCCESS = "ADD_DINNER_SUCCESS";
export const ADD_DINNER_FAILURE = "ADD_DINNER_FAILURE";

export const GET_DINNER_REQUEST = "GET_DINNER_REQUEST";
export const GET_DINNER_SUCCESS = "GET_DINNER_SUCCESS";
export const GET_DINNER_FAILURE = "GET_DINNER_FAILURE";

export const DELETE_DINNER_REQUEST = "DELETE_DINNER_REQUEST";
export const DELETE_DINNER_SUCCESS = "DELETE_DINNER_SUCCESS";
export const DELETE_DINNER_FAILURE = "DELETE_DINNER_FAILURE";

export const ADD_SNACK_REQUEST = "ADD_SNACK_REQUEST";
export const ADD_SNACK_SUCCESS = "ADD_SNACK_SUCCESS";
export const ADD_SNACK_FAILURE = "ADD_SNACK_FAILURE";

export const GET_SNACK_REQUEST = "GET_SNACK_REQUEST";
export const GET_SNACK_SUCCESS = "GET_SNACK_SUCCESS";
export const GET_SNACK_FAILURE = "GET_SNACK_FAILURE";

export const DELETE_SNACK_REQUEST = "DELETE_SNACK_REQUEST";
export const DELETE_SNACK_SUCCESS = "DELETE_SNACK_SUCCESS";
export const DELETE_SNACK_FAILURE = "DELETE_SNACK_FAILURE";
